import {RelativeTime} from '@primer/react'
import type {Commit} from '../types/shared'

import type {AuthorSettings} from '@github-ui/commit-attribution'
import {CommitAttribution as UiCommitAttribution} from '@github-ui/commit-attribution'

import type {Repository} from '@github-ui/current-repository'
import type {PropsWithChildren} from 'react'

interface CommitAttributionProps {
  commit: Commit
  repo: Repository
  settings?: Partial<AuthorSettings>
}

export function CommitAttribution({commit, repo, children, settings}: PropsWithChildren<CommitAttributionProps>) {
  return (
    <UiCommitAttribution
      authors={commit.authors}
      committer={commit.committer}
      committerAttribution={commit.committerAttribution}
      repo={repo}
      includeVerbs={true}
      authorSettings={{fontWeight: 'normal', fontColor: 'fg.muted', avatarSize: 16, ...settings}}
    >
      <RelativeTime sx={{pl: 1}} datetime={commit.committedDate} tense="past" />
      {children}
    </UiCommitAttribution>
  )
}

try{ CommitAttribution.displayName ||= 'CommitAttribution' } catch {}